import { KeyValue } from '@angular/common';
import { WriteNamingConventionItem } from '@project-setup/models/sync';
import { NamingConventionItem } from '.';
import { Sync } from './grid';

export interface NamingConvention {
  id: number;
  subprojectId: number;
  renameReport: boolean;
  renameExport: boolean;
  renameAttachment: boolean;
  renameAppendix: boolean;
  includeNameInReport: boolean;
  namingConventionItemList: KeyValue<number, NamingConventionItem[]>[];
  defaultNamingConventionItemList: KeyValue<number, NamingConventionItem[]>[];
  syncNamingConventionItems: Sync<WriteNamingConventionItem>;
}
